<div class="d-flex card">
	<div class="d-flex">
		<div class="display-6 ms-1 mt-2 mb-1">Gift Cards</div>
		<div class="ms-auto">
			<app-record-control-footer
				[hideAdd]="false"
				[hideCancel]="true"
				[hideDelete]="true"
				[hideSave]="true"
				(onAddChange)="addTransaction()"
			></app-record-control-footer>
		</div>
	</div>
	<p-divider></p-divider>
	<p-tabView (onChange)="changeTab($event)">
		<p-tabPanel headerStyleClass="p-tab-header" *ngIf="venueService.subscriptionOOvenue.value?.giftProcessor === 2">
			<ng-template pTemplate="header">
				<fa-icon [icon]="['far', 'gift-card']" size="lg" class="ms-1"></fa-icon>
				<div class="mx-2">Gift Cards</div>
			</ng-template>
			<app-gift-card-dashboard [(cards)]="cards"></app-gift-card-dashboard>
			<app-gift-card-list [(cards)]="cards"></app-gift-card-list>
		</p-tabPanel>
		<p-tabPanel headerStyleClass="p-tab-header">
			<ng-template pTemplate="header">
				<fa-icon [icon]="['far', 'gift-card']" size="lg" class="ms-1"></fa-icon>
				<div class="mx-2">eGift Cards</div>
			</ng-template>
			<app-e-gift-transactions #eGiftTransactionsComponent></app-e-gift-transactions>
		</p-tabPanel>
		<p-tabPanel headerStyleClass="p-tab-header" *ngIf="venueService.subscriptionOOvenue.value?.giftProcessor === 2">
			<ng-template pTemplate="header">
				<fa-icon [icon]="['far', 'scale-balanced']" size="lg" class="ms-1"></fa-icon>
				<div class="mx-2">Balance Sheet</div>
			</ng-template>
			<app-gift-card-balance-sheet #giftBalanceSheetComponent></app-gift-card-balance-sheet>
		</p-tabPanel>
	</p-tabView>
</div>
